<div class="main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorDashboard()">
      {{ RoutesEnum.OpsVendorsList }}
    </span>
  </div>
  <div class="vendor-list-container">
    <div class="vendor-rto">
      <div class="rto-circle">
        <div class="circle regular"></div>
        <span class="label">{{ RtoTypeEnum.Regular }}</span>
      </div>
      <div class="rto-circle">
        <div class="circle hybrid"></div>
        <span class="label">{{ RtoTypeEnum.Hybrid }}</span>
      </div>
      <div class="rto-circle">
        <div class="circle partial-hybrid"></div>
        <span class="label">{{ RtoTypeEnum.PartialHybrid }}</span>
      </div>
      <div class="rto-circle">
        <div class="circle remote"></div>
        <span class="label">{{ RtoTypeEnum.Remote }}</span>
      </div>
    </div>

    <div class="vendor-search-table-container">
      <div class="vendor-list-search">
        <div class="vendor-title card-title-static">
          <span class="ct-badge"><i class="material-icons">storefront</i></span>
          <span class="ct-text">{{ pageTitle }}</span>
        </div>
        <div class="search-bar-container">
          <div class="search-child">
            <emerald-input [label]="EmeraldLabel.Search" [trailingIcon]="'search'" (keyup)="searchVendors($event)"
              [value]="filterValue"><emerald-icon *ngIf="filterValue?.length && filterValue.length>0" [icon]="'close'"
                (click)="clearInput()"></emerald-icon>
            </emerald-input>
          </div>
          <div class="fs-field">
            <span class="fs-label">Month</span>
            <select class="native-select has-icon icon-cal" aria-label="Month" (change)="onMonthChange($any($event.target).value)">
              <option *ngFor="let o of monthOptions" [value]="o.label" [selected]="o.value === preSelectedValue">{{ o.label }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="vendor-list-table">
        <ng-container *ngIf="displayData?.length; else noDataTemplate">
          <div class="op-table-wrap">
            <table class="op-table vl-table">
              <thead>
                <tr>
                  <th class="sortable" (click)="sortBy('vendorName')">Name <span class="op-sort" [class.asc]="sortField === 'vendorName' && sortDir === 'asc'" [class.desc]="sortField === 'vendorName' && sortDir === 'desc'"></span></th>
                  <th class="sortable c" (click)="sortBy('totalEmployeesHeadCount')">Total Headcount <span class="op-sort" [class.asc]="sortField === 'totalEmployeesHeadCount' && sortDir === 'asc'" [class.desc]="sortField === 'totalEmployeesHeadCount' && sortDir === 'desc'"></span></th>
                  <th class="vl-rto-col">RTO</th>
                  <th class="sortable" (click)="sortBy('pocName')">Contact <span class="op-sort" [class.asc]="sortField === 'pocName' && sortDir === 'asc'" [class.desc]="sortField === 'pocName' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('pocEmail')">Contact Email <span class="op-sort" [class.asc]="sortField === 'pocEmail' && sortDir === 'asc'" [class.desc]="sortField === 'pocEmail' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('pocPhoneNo')">Phone <span class="op-sort" [class.asc]="sortField === 'pocPhoneNo' && sortDir === 'asc'" [class.desc]="sortField === 'pocPhoneNo' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('vendorContractExpiryDate')">Contract Expiry <span class="op-sort" [class.asc]="sortField === 'vendorContractExpiryDate' && sortDir === 'asc'" [class.desc]="sortField === 'vendorContractExpiryDate' && sortDir === 'desc'"></span></th>
                  <th class="sortable" (click)="sortBy('vendorOnboardingDate')">Onboarded On <span class="op-sort" [class.asc]="sortField === 'vendorOnboardingDate' && sortDir === 'asc'" [class.desc]="sortField === 'vendorOnboardingDate' && sortDir === 'desc'"></span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of pagedData">
                  <td><span class="op-jt" (click)="navigationToVendorDetails(v)">{{ v.vendorName }}</span></td>
                  <td class="c mono">{{ v.totalEmployeesHeadCount ?? '—' }}</td>
                  <td class="vl-rto-col">
                    <section class="progress-bar">
                      <ng-container *ngFor="let type of rtoSegments">
                        <div class="segment {{ type.class }}" [style.width.%]="v[type.key] || 0">
                          {{ v[type.key] == null ? 0 : v[type.key] }}%
                        </div>
                      </ng-container>
                    </section>
                  </td>
                  <td [attr.title]="v.pocName || null">{{ v.pocName || '—' }}</td>
                  <td [attr.title]="v.pocEmail || null">{{ v.pocEmail || '—' }}</td>
                  <td class="mono" [attr.title]="v.pocPhoneNo || null">{{ v.pocPhoneNo || '—' }}</td>
                  <td>{{ v.vendorContractExpiryDate || '—' }}</td>
                  <td>{{ v.vendorOnboardingDate || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="op-tfoot">
            <div class="op-info">
              Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ displayData.length }}</b> vendors
            </div>
            <div class="op-pager">
              <button class="pg" (click)="prevPage()" [disabled]="pageIndex === 1" aria-label="Previous page">‹</button>
              <button
                *ngFor="let pnum of pageWindow; trackBy: trackByIndex"
                class="pg"
                [class.on]="pnum === pageIndex"
                [disabled]="pnum === -1"
                (click)="goToPage(pnum)"
              >{{ pnum === -1 ? '…' : pnum }}</button>
              <button class="pg" (click)="nextPage()" [disabled]="pageIndex >= totalPages" aria-label="Next page">›</button>
            </div>
            <div class="op-psize">
              <span>Rows</span>
              <select [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Rows per page">
                <option [value]="10">10</option>
                <option [value]="25">25</option>
                <option [value]="50">50</option>
              </select>
            </div>
          </div>
        </ng-container>
        <ng-template #noDataTemplate>
          <section class="records-container" aria-label="Records section">
            <div class="empty-state">
              <ng-container *ngIf="isDataLoaded">
                <h2 class="empty-state-title">{{ errorMsg }}</h2>
              </ng-container>
              <img [src]="imageSrc" alt="{{ noDataMessage }}" class="empty-state-image" />
            </div>
          </section>
        </ng-template>
      </div>
    </div>
  </div>

  <app-modal-wrapper *ngIf="showVendorProfile" [showModal]="showVendorProfile">
    <app-vendor-profile-page
      [vendorData]="selectedVendor"
      (close)="showVendorProfile = false"
    ></app-vendor-profile-page>
  </app-modal-wrapper>
</div>